class SwiperInitializer {
  constructor() {
    this.swipers = [];
  }

  /**
   * Initializes Swiper instances based on the provided configuration.
   *
   * @param {string} containerSelector - CSS selector for the Swiper container(s).
   * @param {object} options - Swiper configuration options.
   * @param {object} [selectors] - Optional selectors for navigation and pagination elements.
   * @param {string} [selectors.nextEl] - CSS selector for the next button.
   * @param {string} [selectors.prevEl] - CSS selector for the previous button.
   * @param {string} [selectors.paginationEl] - CSS selector for the pagination element.
   * @param {string} [selectors.pagination_type] - Type of pagination to use
   */

  init(
    containerSelector,
    options,
    selectors = { pagination_type: 'progressbar' },
  ) {
    const containers = document.querySelectorAll(containerSelector);
    if (!containers.length) return;

    this.destroySwipers();

    containers.forEach((container) => {
      const swiperOptions = {
        ...options,
        navigation: {
          nextEl: container.querySelector(selectors.nextEl),
          prevEl: container.querySelector(selectors.prevEl),
        },
        pagination: {
          el: container.querySelector(selectors.paginationEl),
          clickable: true,
          type: selectors.pagination_type,
        },
        on: {
          touchStart: () => {
            container.querySelectorAll('video').forEach((v) => {
              v.style.pointerEvents = 'none';
            });
          },
          touchEnd: () => {
            setTimeout(() => {
              container.querySelectorAll('video').forEach((v) => {
                v.style.pointerEvents = '';
              });
            }, 200);
          },
          // This prevents the carousel from shifting when a video inside gains focus
          click: (s, e) => {
            if (s.animating) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
        },
      };

      if (window?.Swiper) {
        const swiperElement = container.querySelector('.swiper');
        const swiper = new window.Swiper(swiperElement, swiperOptions);
        this.swipers.push(swiper);
      }
    });
  }

  destroySwipers() {
    this.swipers.forEach((swiper) => {
      if (swiper.destroy) swiper.destroy(true, true);
    });
    this.swipers = [];
  }
}
